import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ManagepayoutComponent } from './managepayout.component';
import { ManagepayoutsComponent } from './managepayouts.component';

const routes: Routes = [
    {
        path: '',
        component: ManagepayoutComponent,
        data: {
            title: 'Manage Order'
        }
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class ManagePayOutRoutingModule { }
